/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Modal, Text } from '@az/starc-ui';
import { useState } from 'react';
import styles from './HeroHeaderContent.module.scss';

type Props = {
  text: string;
  isDarkBackground: boolean;
  copy?: string;
  className?: string;
  textColor?: string;
};

const LegalText = ({ text, isDarkBackground, copy, className, textColor }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const themeColor = isDarkBackground ? 'on-primary' : 'primary';

  const textElement = (
    <Text
      as="span"
      variant="text-link"
      color={textColor ? undefined : themeColor}
      weight="medium"
      decoration="underline"
      className={`${isDarkBackground ? styles.LegalTextOnDark : styles.LegalTextOnLight}`}
      attributes={textColor ? { style: { color: textColor } } : undefined}
    >
      {text}
    </Text>
  );

  if (!copy) {
    return <span className={className}>{textElement}</span>;
  }

  return (
    <>
      <button
        type="button"
        className={`${styles.LegalButton} ${className ?? ''}`}
        onClick={() => setIsOpen(true)}
      >
        {textElement}
      </button>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        hasCloseButton
        size={{ s: 'full', m: 'small' }}
      >
        <div dangerouslySetInnerHTML={{ __html: copy }} />
      </Modal>
    </>
  );
};

export default LegalText;
